import * as React from "react";
import { BrowserRouter } from "react-router-dom";
import { SWRConfig } from "swr";

import { apiFetchWithAuth } from "./api";
import AppRoutes from "./AppRoutes";
import ErrorPopup from "./components/ErrorPopup";
import { ErrorAlertProvider } from "./hooks/useErrorAlert";

function App() {
  return (
    <ErrorAlertProvider>
      <AppInner />
    </ErrorAlertProvider>
  );
}

function AppInner() {
  // TODO: Find out a better way to use this with swr.
  // This causes UI confusion as it is.
  // const { setError } = useErrorAlert();
  // const onError = (error: Error) => setError(getGenericErrorInfo(error));

  const onError = () => null;

  return (
    <SWRConfig value={{ fetcher: apiFetchWithAuth, onError }}>
      {/* TODO: re-enable strict mode once react-spring-bottom-sheet patched */}
      {/* <React.StrictMode> */}
      <ErrorPopup />
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
      {/* </React.StrictMode> */}
    </SWRConfig>
  );
}

export default App;
